export default __webpack_public_path__ + "static/media/ReFPay4.8077191a.svg";